"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  deselectAll: {
    "id": "Combobox.deselectAll",
    "defaultMessage": "Deselect All"
  },
  noResultsFound: {
    "id": "Combobox.noResultsFound",
    "defaultMessage": "No results found"
  },
  searchPlaceholderText: {
    "id": "common.forms.searchPlaceholderText",
    "defaultMessage": "Search"
  },
  selected: {
    "id": "Combobox.selected",
    "defaultMessage": "Selected"
  },
  itemsInfo: {
    "id": "itemsInfo",
    "defaultMessage": "You can select up to {itemsNumber, number} items at a time. Deselect an item to select another item."
  },
  selectFilteredItems: {
    "id": "Combobox.selectFilteredItems",
    "defaultMessage": "Select {count, number} {count, plural, one {item} other {items}}"
  },
  apply: {
    "id": "common.actions.apply",
    "defaultMessage": "Apply"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map